import '@/styles/main.scss';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import i18n from './i18n';
import App from './App.vue';
import router from './router';

import * as SentryVue from '@sentry/vue';
import { getSentryOptions } from './sentry';

const app = createApp(App);

SentryVue.init(getSentryOptions(app));

i18n.setup();

app.use(i18n.vueI18n);
app.use(createPinia());
app.use(router);

app.mount('#app');
